export default {
	"vehicleTrack": {
		"DateTime": "datetime"
	},
	"zdTrack": {
		"reanalysis": "reanalyse",
		"send": "send",
		"sendTo": "Sent",
		"receive": "receive"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/components/zdTrack/zdTrack.js